import request from '@/utils/request'

// 查询拓客用户列表
export function listUser(query) {
  return request({
    url: '/expand/user/list',
    method: 'get',
    params: query
  })
}

// 查询拓客用户详细
export function getUser(id) {
  return request({
    url: '/expand/user/' + id,
    method: 'get'
  })
}

// 新增拓客用户
export function addUser(data) {
  return request({
    url: '/expand/user',
    method: 'post',
    data: data
  })
}

// 修改拓客用户
export function updateUser(data) {
  return request({
    url: '/expand/user',
    method: 'put',
    data: data
  })
}

// 删除拓客用户
export function delUser(id) {
  return request({
    url: '/expand/user/' + id,
    method: 'delete'
  })
}
// 查询图片
export function getImage(id) {
  return request({
    url: '/resource/oss/listByIds/' + id,
    method: 'get'
  })
}

// 查询拓客专员的的直推列表
export function getMemberListByExpandUserId(query) {
  return request({
    url: 'expand/bind/getMemberListByExpandUserId',
    method: 'get',
    params: query
  })
}

// 查询拓客经理的专员列表
export function getExpandAttacheList(query) {
  return request({
    url: 'expand/bind/getExpandAttacheList',
    method: 'get',
    params: query
  })
}

export function getLink(query) {
  return request({
    url: 'expand/user/getLink',
    method: 'get',
    params: query
  })
}

export function setExtensionWorker(param) {
  return request({
    url: 'expand/user/setExtensionWorker',
    method: 'post',
    params: param
  })
}

export function resetPassword(data) {
  return request({
    url: '/expand/user/resetPassword',
    method: 'post',
    data: data
  })
}

// 查询拓客经理列表（状态正常的经理）
export function getManagerList() {
  return request({
    url: '/expand/user/getManagerList',
    method: 'get'
  })
}

// 查询拓客经理的拓客角色列表
export function getRoleListByManagerId(userId) {
  return request({
    url: '/expand/user/getRoleListByManagerId/' + userId,
    method: 'get'
  })
}

// 查询拓客用户授权角色
export function getAuthRole(userId) {
  return request({
    url: '/expand/user/authRole/' + userId,
    method: 'get'
  })
}

// 保存拓客用户授权角色
export function updateAuthRole(data) {
  return request({
    url: '/expand/user/authRole',
    method: 'put',
    params: data
  })
}
